import { GroupAgentDetails, GroupAgentEditDetails, QueryParams } from "@/sharedTypes";
import { baseApi } from "../baseApi";
import { flattenQueryParams } from "@/utils/requestUtils";

const agentGroupTag = "AgentGroup";

export const agentGroupApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    assignAgentToGroup: builder.mutation<any, GroupAgentDetails>({
      query: (groupAgentDetails) => ({
        url: `/agentGroup`,
        method: "POST",
        body: groupAgentDetails,
      }),
      invalidatesTags: [agentGroupTag],
    }),
    getAgentsInGroup: builder.query<any, { groupId: string; params: QueryParams }>({
      query: ({ groupId, params }) => {
        const queryString = params
          ? `?${new URLSearchParams(flattenQueryParams(params)).toString()}`
          : "";
        return `/agentGroup/groups/${groupId}${queryString}`;
      },
      providesTags: [agentGroupTag],
    }),
    getAgentsInMyGroups: builder.query<any, QueryParams>({
      query: (params) => {
        const queryString = params
            ? `?${new URLSearchParams(flattenQueryParams(params)).toString()}`
            : "";
        return `/agentGroup/agents_in_my_groups/${queryString}`;
      },
      providesTags: [agentGroupTag]
    }),
    editAgentInGroup: builder.mutation<any, GroupAgentEditDetails>({
      query: (updatedDetails) => {
        const { agent_id, group_id, ...rest } = updatedDetails;
        return {
          url: `/agentGroup/${group_id}/agent/${agent_id}`,
          method: "PUT",
          body: rest,
        }
      },
      invalidatesTags: [agentGroupTag],
    }),
    removeAgentFromGroup: builder.mutation<any, { groupId: string; agentId: string }>({
      query: ({ groupId, agentId }) => ({
        url: `/agentGroup/${groupId}/agent/${agentId}`,
        method: "DELETE",
      }),
      invalidatesTags: [agentGroupTag],
    }),
  }),
});

export const {
  useAssignAgentToGroupMutation,
  useGetAgentsInGroupQuery,
  useGetAgentsInMyGroupsQuery,
  useEditAgentInGroupMutation,
  useRemoveAgentFromGroupMutation,
} = agentGroupApi;
